import { useCallback, useEffect } from 'react'
import { useSignal } from '@preact/signals-react'
import { getSubmit } from '@ui-seeker/utils'

import { BACKEND_APIS } from '@constants'
import { useToast } from '@hooks'
import { isOpenGroupingExportsModal, groupingExecutionType } from '../@signals'


export default function useGroupedExportsModal() {
	const data = useSignal([])
	const isLoading = useSignal(false)
	const { showToast } = useToast()
	const isExtra = window.location.pathname.includes('extra')
	

	const getData = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.REPORT}/export-group-reports`, {
			id: isOpenGroupingExportsModal.value,
			executionType: isExtra ? 'execution-extras' : groupingExecutionType.value,
		})
			.then(res => {
				data.value = res
				isLoading.value = false
			})
			.catch(() => {
				showToast.error('Server Error: Could not load exported data.')
				isLoading.value = false
			})
	}, [ isExtra ])


	useEffect(() => {
		if (isOpenGroupingExportsModal.value) getData()
	}, [ isOpenGroupingExportsModal.value ])


	return {
		data: data.value,
		isLoading: isLoading.value,
	}
}